/**
 * File upload configuration constants
 * Centralized configuration for file upload components
 */

export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB

/**
 * Maximum number of files allowed in a single batch upload
 * Prevents DoS attacks and resource exhaustion
 */
export const MAX_BATCH_UPLOAD_SIZE = 50;

export const EXTENSION_TO_CONTENT_TYPE = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls: 'application/vnd.ms-excel',
  csv: 'text/csv',
  pdf: 'application/pdf',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  xlsm: 'application/vnd.ms-excel.sheet.macroEnabled.12',
  xltm: 'application/vnd.ms-excel.template.macroEnabled.12',
  xltx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  docm: 'application/vnd.ms-word.document.macroEnabled.12',
  dotm: 'application/vnd.ms-word.template.macroEnabled.12',
  dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
} as const;

export const ALLOWED_EXTENSIONS = new Set(Object.keys(EXTENSION_TO_CONTENT_TYPE));

export type FileExtension = keyof typeof EXTENSION_TO_CONTENT_TYPE;

// Backward compatibility aliases
export { MAX_FILE_SIZE as MaxDataCollectionFileSize };
export { ALLOWED_EXTENSIONS as allowedExtensions };
